/**
 * Google Maps Places attaches a dropdown with class `pac-container` to the document.
 * When it is visible, Enter must not submit a parent <form> (user is picking a suggestion).
 * @returns {boolean}
 */
export function isGooglePlacesPacVisible() {
  const pac = document.querySelector('.pac-container');
  if (!pac) return false;
  const style = window.getComputedStyle(pac);
  if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
    return false;
  }
  const r = pac.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
}
